module.exports = __webpack_public_path__ + "static/media/picture0@2x.c94654a6.png";